import { actionCreator } from '@ardoq/rxbeach';

export const resetGraph = actionCreator('[graphModel] RESET_GRAPH');
